var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmr02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pcelxzfv1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15446",
    style: {
      fill: "none"
    },
    d: "M0 0h60v60H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 18",
    transform: "translate(24.925 13.283)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h19.813"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 19",
    transform: "translate(15.262 13.283)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h3.221"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 20",
    transform: "translate(24.925 21.339)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h16.775"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 21",
    transform: "translate(15.262 21.339)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h3.221"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 22",
    transform: "translate(24.925 29.395)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h19.813"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 23",
    transform: "translate(15.262 29.395)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h3.221"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59583",
    d: "m27.43 51.925 4.149 4.149 8.391-8.391",
    transform: "translate(-3.7 -9.255)",
    style: {
      stroke: "#4cbbb8",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 735"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 734",
    style: {
      clipPath: "url(#pcelxzfv1a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15445",
    transform: "translate(7.074 5.682)",
    style: {
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 4,
      stroke: "#999",
      fill: "none"
    },
    d: "M0 0h45.851v48.636H0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmr02);
export default __webpack_public_path__ + "static/media/amr_02.147652b57791ce7557cfe7ca697cfe48.svg";
export { ForwardRef as ReactComponent };